module.exports = "/_next/static/images/game-1-phone-attachment-cake-2f3cd87c216c264b6f8d789feb6d00ea.jpg";